import random from 'helpers/random';

angular.module('gym.components').directive('sequenceTaskPayloadEditor', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/sequenceTaskPayloadEditor.html.slim'),
    scope: {
      payload: '=',
      sequence: '=',
      taskTypes: '=',
      displayErrors: '='
    },
    controller: ["$scope", "$rootScope", "EventDefaultsService", "isInteger", function($scope, $rootScope, EventDefaultsService, isInteger) {
      var timeAry;
      $scope.id = random();
      $scope.users = $rootScope.gym.users;
      $scope.params = {};
      if ($scope.payload.due_date_time) {
        timeAry = $scope.payload.due_date_time.split(':');
        $scope.params.dueTime = moment().hours(timeAry[0]).minutes(timeAry[1]);
        $scope.payload.dueDateEnabled = $scope.payload.due_date_day_delta > -1;
      }
      $scope.deltaInvalid = function() {
        return !isInteger($scope.payload.due_date_day_delta) || $scope.payload.due_date_day_delta < 0;
      };
      $scope.onTimeChange = function() {
        if ($scope.params.dueTime) {
          return $scope.payload.due_date_time = moment($scope.params.dueTime).format('HH:mm');
        } else {
          return $scope.payload.due_date_time = void 0;
        }
      };
      $scope.toggleDueDate = function(enabled) {
        if (!enabled) {
          $scope.payload.due_date_day_delta = void 0;
          $scope.payload.due_date_time = void 0;
        }
        return $scope.payload.dueDateEnabled = enabled;
      };
      return $scope.toggleTime = function(val) {
        if (val) {
          $scope.params.dueTime = EventDefaultsService.getRoundedTime(moment(), 15);
        } else {
          $scope.params.dueTime = void 0;
        }
        return $scope.onTimeChange();
      };
    }]
  };
});
